import type { CrmTranslate } from './crm-copy';

export function createCrmWorkflowCopy(t: CrmTranslate) {
  return {
    taskForm: {
      titles: {
        create: t('crm.taskForm.titles.create'),
        edit: t('crm.taskForm.titles.edit'),
      },
      actions: {
        cancel: t('crm.taskForm.actions.cancel'),
        create: t('crm.taskForm.actions.create'),
        saveChanges: t('crm.taskForm.actions.saveChanges'),
        saving: t('crm.taskForm.actions.saving'),
      },
      labels: {
        entityType: t('crm.taskForm.labels.entityType'),
        entityId: t('crm.taskForm.labels.entityId'),
        title: t('crm.taskForm.labels.title'),
        description: t('crm.taskForm.labels.description'),
        status: t('crm.taskForm.labels.status'),
        priority: t('crm.taskForm.labels.priority'),
        ownerId: t('crm.taskForm.labels.ownerId'),
        dueAt: t('crm.taskForm.labels.dueAt'),
      },
      entityTypes: {
        property: t('crm.taskForm.entityTypes.property'),
        listing: t('crm.taskForm.entityTypes.listing'),
        portalLead: t('crm.taskForm.entityTypes.portalLead'),
        showing: t('crm.taskForm.entityTypes.showing'),
        offer: t('crm.taskForm.entityTypes.offer'),
        transaction: t('crm.taskForm.entityTypes.transaction'),
      },
      statuses: {
        open: t('crm.taskForm.statuses.open'),
        completed: t('crm.taskForm.statuses.completed'),
        cancelled: t('crm.taskForm.statuses.cancelled'),
      },
      priorities: {
        low: t('crm.taskForm.priorities.low'),
        medium: t('crm.taskForm.priorities.medium'),
        high: t('crm.taskForm.priorities.high'),
      },
      messages: {
        saveFailed: t('crm.taskForm.messages.saveFailed'),
      },
    },
    tasksPage: {
      documentTitle: t('crm.tasksPage.documentTitle'),
      title: t('crm.tasksPage.title'),
      counts: {
        tasks: (count: number) =>
          t('crm.tasksPage.counts.tasks', {
            values: { count },
          }),
      },
      actions: {
        grid: t('crm.tasksPage.actions.grid'),
        list: t('crm.tasksPage.actions.list'),
        newTask: t('crm.tasksPage.actions.newTask'),
        advancedFilters: t('crm.tasksPage.actions.advancedFilters'),
        complete: t('crm.tasksPage.actions.complete'),
        edit: t('crm.tasksPage.actions.edit'),
        delete: t('crm.tasksPage.actions.delete'),
        confirm: t('crm.tasksPage.actions.confirm'),
        cancel: t('crm.tasksPage.actions.cancel'),
      },
      search: {
        placeholder: t('crm.tasksPage.search.placeholder'),
      },
      sort: {
        label: t('crm.tasksPage.sort.label'),
        due: t('crm.tasksPage.sort.due'),
        title: t('crm.tasksPage.sort.title'),
        status: t('crm.tasksPage.sort.status'),
        priority: t('crm.tasksPage.sort.priority'),
        created: t('crm.tasksPage.sort.created'),
      },
      states: {
        errorTitle: t('crm.tasksPage.states.errorTitle'),
        loadingTitle: t('crm.tasksPage.states.loadingTitle'),
        loadingDescription: t('crm.tasksPage.states.loadingDescription'),
        emptyTitle: t('crm.tasksPage.states.emptyTitle'),
        searchEmptyDescription: t('crm.tasksPage.states.searchEmptyDescription'),
        startEmptyDescription: t('crm.tasksPage.states.startEmptyDescription'),
      },
      fallbacks: {
        noDueDate: t('crm.tasksPage.fallbacks.noDueDate'),
        noDescriptionProvided: t('crm.tasksPage.fallbacks.noDescriptionProvided'),
      },
      details: {
        entitySubtitle: (entityType: string, entityId: string) =>
          t('crm.tasksPage.details.entitySubtitle', {
            values: { entityType, entityId },
          }),
        priorityStatus: (priority: string, status: string) =>
          t('crm.tasksPage.details.priorityStatus', {
            values: { priority, status },
          }),
      },
      statuses: {
        open: t('crm.tasksPage.statuses.open'),
        completed: t('crm.tasksPage.statuses.completed'),
        cancelled: t('crm.tasksPage.statuses.cancelled'),
      },
      priorities: {
        low: t('crm.tasksPage.priorities.low'),
        medium: t('crm.tasksPage.priorities.medium'),
        high: t('crm.tasksPage.priorities.high'),
      },
      entityTypes: {
        property: t('crm.tasksPage.entityTypes.property'),
        listing: t('crm.tasksPage.entityTypes.listing'),
        portalLead: t('crm.tasksPage.entityTypes.portalLead'),
        showing: t('crm.tasksPage.entityTypes.showing'),
        offer: t('crm.tasksPage.entityTypes.offer'),
        transaction: t('crm.tasksPage.entityTypes.transaction'),
      },
      pagination: {
        entityLabel: t('crm.tasksPage.pagination.entityLabel'),
      },
      confirmations: {
        deleteTitle: t('crm.tasksPage.confirmations.deleteTitle'),
        deleteMessage: (title: string) =>
          t('crm.tasksPage.confirmations.deleteMessage', {
            values: { title },
          }),
      },
      messages: {
        loadFailed: t('crm.tasksPage.messages.loadFailed'),
        deleteFailed: t('crm.tasksPage.messages.deleteFailed'),
        deleted: t('crm.tasksPage.messages.deleted'),
        updateFailed: t('crm.tasksPage.messages.updateFailed'),
        completed: t('crm.tasksPage.messages.completed'),
        updated: t('crm.tasksPage.messages.updated'),
        saved: t('crm.tasksPage.messages.saved'),
      },
    },
  };
}
